import axios from 'axios'

//获取accessToken https://testintegration.cloudcc.com/api/huanxin/getClodccToken
export function getClodccToken(data) {
    return axios.post(window.Glod['ex-integration-svc'] + "/api/huanxin/getClodccToken", data)
}